import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ModalController, ActionSheetController } from '@ionic/angular';

import { ProductsService } from 'src/app/lib/services/products.service';
import { StorageService } from 'src/app/lib/services/storage.service';
import { Constants } from 'src/app/config/constants';
import { CommonService } from 'src/app/lib/services/common.service';
import { LanguageService } from 'src/app/lib/services/language.service';
import { Router } from '@angular/router';
import { TopItemsCatalogComponent } from 'src/app/pages/catelog/top-items-catalog/top-items-catalog.component';

@Component({
  selector: 'app-add-catalog-modal',
  templateUrl: './add-catalog-modal.component.html',
  styleUrls: ['./add-catalog-modal.component.scss'],
  standalone: false
})
export class AddCatalogModalComponent implements OnInit {

  masterCategoryArray: any;
  categories = [];
  selectedCategories = [];
  categoryPresentinBackend = []//Array consists of all the categories selected by users
  searchLang: any;
  selectedtab = 'product';
  sellingType: boolean = true;
  disableProduct: boolean = false;
  disableService: boolean = false;
  isLoading: boolean = true;
  clickDisable: any;
  constructor(
    private router: Router,
    public commonService: CommonService,
    private storageService: StorageService,
    private productsService: ProductsService,
    private modalController: ModalController,
    private languageService: LanguageService,
  ) { }

  ngOnInit() { }

  ionViewWillEnter() {
    this.getSpashScreenData();
  }
  /**
     * @name getSpashScreenData
     * @type Function - Get all allCategories, microcategories, and products
     ***/
  async getSpashScreenData() {
    this.commonService.presentProgressBarLoading();
    const catalogPresentInStorage = await this.storageService.getItemNativeCatalog(Constants.MASTER_CATALOGUE);
    if (catalogPresentInStorage) {
      this.handleExistingCatalog(catalogPresentInStorage);
      this.commonService.closeProgressBarLoading();
    } else {
      try {
        const apiResponse = await this.productsService.getSplashApi().toPromise();
        this.commonService.closeProgressBarLoading();
        this.handleCatalogFromApiResponse(apiResponse);
      } catch (error) {
        this.commonService.closeProgressBarLoading();
        console.error('Error fetching splash API:', error);
      }
    }
  }

  handleExistingCatalog(catalogPresentInStorage: any) {
    const jsonObj = JSON.parse(catalogPresentInStorage);
    this.masterCategoryArray = jsonObj.masterCatalogData.catalog;
    this.getCatalogDataFromBackend();
  }

  async handleCatalogFromApiResponse(apiResponse: any) {
    if (apiResponse && apiResponse.data && apiResponse.data.catalogue_meta && apiResponse.data.catalogue_meta['masterCatalog']) {
      const urls = { masterCatalogData: apiResponse.data.catalogue_meta['masterCatalog'][0].url };
      try {
        const data = await this.productsService.homegetProductsListNew(urls).toPromise();
        if (data) {
          this.masterCategoryArray = data.masterCatalogData['catalog'];
          this.storageService.setItemNativeCatalog(Constants.MASTER_CATALOGUE, data);
          this.getCatalogDataFromBackend();
        }
      } catch (error) {
        console.error('Error fetching catalog data from backend:', error);
      }
    } else {
      console.error('Master catalog not found in API response');
    }
  }

  ionViewWillLeave() {
    if (!this.selectedCategories.length) {
      this.storageService.removeItemNativeCatalog(Constants.SELECTED_CATEGORIES);
    }
  }

  async isSellingService(value: boolean) {
    this.commonService.presentProgressBarLoading();
    try {
      const res: any = await this.productsService.updateSellingType({ "service": value }).toPromise();
      this.commonService.success(res.data);
    } catch (error) {
      console.log(error);
    } finally {
      this.commonService.closeProgressBarLoading();
    }
  }

  getCategoriesData() {
    return this.masterCategoryArray.filter((res: any) => res.type == this.selectedtab);
  }

  async getCatalogDataFromBackend() {
    const loading = await this.commonService.presentLoader();
    loading.present();
    try {
      this.selectedCategories = [];
      this.categoryPresentinBackend = [];
      const resp: any = await this.productsService.getCatalogList().toPromise();
      if (resp['success']) {
        this.isLoading = false;
        const retailerCatalog = resp['data'].catalog || [];
        const service = resp['data'].shop?.service;
        if (service) {
          this.selectedtab = 'service';
          retailerCatalog?.length ? this.disableProduct = true : '';
        } else {
          this.selectedtab = 'product';
          retailerCatalog?.length ? this.disableService = true : '';
        }
        const savedCatalog = retailerCatalog.map((catalog: any) => {
          this.categoryPresentinBackend.push(catalog.name);
          return catalog.id;
        });
        let selectedCat = []
        this.masterCategoryArray.forEach((master: any) => {
          if (savedCatalog.includes(master.id)) {
            selectedCat.push(master);
            master.checked = true;
          }
        });
        this.selectedCategory(selectedCat, loading);
      }
    } catch (error) {
      loading.dismiss();
      console.log(error);
    }
  }

  async selectedCategory(categories: any, loading: any) {
    if (!categories || categories.length === 0) {
      loading.dismiss();
      return; // No need to proceed if there are no categories
    }
    try {
      const promises = categories.map((category: any) =>
        this.languageService.selectLanguageCDN(category.categoriesUrl).toPromise());
      const results = await Promise.all(promises);
      this.selectedCategories.push(...results);
    } catch (error) {
      // this.commonService.danger(error?.message);
      console.error(error);
    } finally {
      loading.dismiss();
    }
  }

  /**
   * @name chooseCategory
   * @type Function - Select/Unselect the allCategories
   * @param evt - Event triggred on click
   * @param id - Category Id
   * **/
  chooseCategory(category: any): void {
    if (this.categoryPresentinBackend.includes(category.name)) {
      this.commonService.danger(`Cannot unselect this category`);
    } else {
      this.commonService.presentLoader().then((loading: any) => {
        loading.present();
        this.languageService.selectLanguageCDN(category.categoriesUrl).subscribe((categories: any) => {
          loading.dismiss();
          this.openTopItemSelection(category);
          if (this.selectedCategories.filter(res => res.id == category.id)?.length) {
            let categoryExistsIndexID = this.selectedCategories.filter(res => res.id != category.id);
            this.selectedCategories = categoryExistsIndexID;
            if (!this.selectedCategories.length) {
              this.disableProduct = false;
              this.disableService = false;
            }
          } else {
            const matchedCategory = this.masterCategoryArray.find((category: any) => category.id === categories.id && category.type === 'service');
            if (matchedCategory) {
              this.disableProduct = true;
            } else {
              this.disableService = true;
            }
            this.selectedCategories.push(categories);
          }
        }, err => {
          loading.dismiss();
          console.log(err);
        });
      })
    }
  }

  async openTopItemSelection(category: any) {
    if (category.checked) {
      this.clickDisable = 'disableClickCss'
      const model = await this.modalController.create({
        component: TopItemsCatalogComponent,
        cssClass: 'TopCatalogItem-component-css',
        componentProps: {
          category: category
        },
      });
      await model.present();
      const { data } = await model.onWillDismiss();
      console.log(data);
      this.clickDisable = ''
    }
  }

  searchFunction() {
    this.categories = this.masterCategoryArray.filter((category: any) =>
      category.name.toLowerCase().includes(this.searchLang.toLowerCase()));
  }

  navigate() {
    if (this.selectedCategories?.length) {
      this.storageService.setItemNativeCatalog(Constants.SELECTED_CATEGORIES, this.selectedCategories);
      this.router.navigate([`/select-food`]);
    } else {
      this.commonService.presentToast('Please choose a category to continue.');
    }
  }
}